import { Button, Card, Col, Result, Row, Spin } from 'antd';
import { Icon } from 'components';
import React, { useEffect } from 'react';
import { MdFileDownload } from 'react-icons/md';
import { NavLink } from 'react-router-dom';
import { getRequieredProgram } from 'services/auth';
import { getDocuments } from 'services/notice';
import styled from 'styled-components';
import { PromiseAllSettled } from 'utils/Polyfills';
import ReqAppConfig from '../config/required_app.config';
import { FaqList } from '../help/Faq';
import NoticeList from '../help/notice/List';
import { AvailableGroupVds } from './components';

const StyledResult = styled(Result)`
  padding: 32px;
  height: 220px;
  .ant-result-icon {
    margin-bottom: 8px;
  }
`;

const StyledCard = styled(Card)`
  background-color: #ecf1f6;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  .ant-card-head {
    padding-top: 12px;
    padding-bottom: 0px;
    .ant-card-head-title {
      padding: 0;
      font-size: 14px;
    }
  }
  .ant-card-body {
    padding: 24px;
  }
`;

function Desktops({ location }) {
  const [RequiredAppsInstalled, setRequiredAppsInstalled] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [faq, setFaq] = React.useState([]);
  const [activeTabKey, setActiveTabKey] = React.useState('notice'); // 활성화된 탭
  const [vdsRefresh, setVdsRefresh] = React.useState(false);

  useEffect(() => {
    setLoading(true);
    // mgmt로 부터 현재 확인해야하는 프로그램 목록을 가져온다.
    const loadingFunc = async () => {
      const programs = await getRequieredProgram();
      return programs;
    };

    loadingFunc().then((programs) => {
      const dataLoading = Object.entries(ReqAppConfig.requiredProgram(programs)).map(
        async ([_, v]) => {
          const state = v.onInstallCheck
            ? (await PromiseAllSettled(await v.onInstallCheck(window)))
                .map((result) => result.value)
                .some(Boolean)
            : true;

          return state;
        },
      );

      PromiseAllSettled(dataLoading).then((data) => {
        // 모든 필수 항목들이 설치되어있는지 확인
        setRequiredAppsInstalled(data.map((d) => d.value).every(Boolean));
        setLoading(false);
      });

      getDocuments({ current: 1, pageSize: 5, type: 'faq' }).then((docs) => setFaq(docs.data));
    });
  }, []);

  // 탭 리스트
  const tabContentList = {
    notice: <NoticeList recent />,
    FAQ: <FaqList accordion docs={faq} />,
  };

  return (
    <Row gutter={[0, 40]} style={{ width: 980 }}>
      <Col span={24}>
        <StyledCard bordered={false}>
          {loading ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: 220,
              }}
            >
              <Spin spinning={loading} tip="필수 프로그램 설치를 확인 중입니다." />
            </div>
          ) : (
            <>
              {!RequiredAppsInstalled ? (
                <StyledResult
                  status="error"
                  title="필수 프로그램이 설치되지 않았습니다."
                  subTitle="아래 프로그램 다운로드를 통하여 설치 후 새로고침하시기 바랍니다."
                  extra={[
                    <NavLink to="/help/download" key="download">
                      <Button type="primary" icon={<Icon name={<MdFileDownload />} />}>
                        프로그램 다운로드
                      </Button>
                    </NavLink>,
                  ]}
                />
              ) : (
                <AvailableGroupVds
                  refresh={vdsRefresh}
                  redirectUrlToVd={location?.redirectUrlToVd}
                  setVdsRefresh={setVdsRefresh}
                  onRefresh={() => {
                    setVdsRefresh(false);
                  }}
                />
              )}
            </>
          )}
        </StyledCard>
      </Col>
      <Col span={24}>
        <Card
          tabList={[
            {
              key: 'notice',
              tab: '공지사항',
            },
            {
              key: 'FAQ',
              tab: 'FAQ',
            },
          ]}
          activeTabKey={activeTabKey}
          tabBarExtraContent={
            <NavLink to={activeTabKey === 'notice' ? '/help/notice/list' : '/help/faq'}>
              <Button size="small" type="link">
                더 보기
              </Button>
            </NavLink>
          }
          onTabChange={(key) => {
            setActiveTabKey(key);
          }}
        >
          {tabContentList[activeTabKey]}
        </Card>
      </Col>
    </Row>
  );
}

export default Desktops;
